import { render, staticRenderFns } from "./viewSupplier.vue?vue&type=template&id=35d4254e&"
import script from "./viewSupplier.vue?vue&type=script&lang=js&"
export * from "./viewSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports